import React, { PropsWithChildren } from 'react';

import clsxm from '@/lib/clsxm';

import { Content } from './layout';

export interface IProps {
  className?: string;
}

const FloatingBar: React.FC<PropsWithChildren<IProps>> = ({
  className,
  children,
}) => {
  return (
    <div
      className={clsxm(
        'fixed bottom-0 z-10 flex w-full items-center justify-center bg-white py-6 shadow-[0_-16px_32px_rgba(0,0,0,0.1)]',
        className
      )}
    >
      <Content>{children}</Content>
    </div>
  );
};

export default FloatingBar;
